import { render, staticRenderFns } from "./MyLoan.vue?vue&type=template&id=5054f1c2&"
import script from "./MyLoan.vue?vue&type=script&lang=js&"
export * from "./MyLoan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports